export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayFabricName') || '面料名称',
    field: 'displayFabricName',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricName' },
  },
  {
    title: that.$l('table_label_fabricStatus') || '状态',
    field: 'fabricStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricStatus' },
  },
  {
    title: that.$l('table_label_displayWid') || '颜色克重',
    field: 'displayWid',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWid' },
  },
  {
    title: that.$l('table_label_displayFabricContent') || '面料成分',
    field: 'displayFabricContent',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricContent' },
  },
  {
    title: that.$l('table_label_fabricAgentName') || '业务开发',
    field: 'fabricAgentName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayPrice') || '单价',
    field: 'displayPrice',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPrice' },
  },
  {
    title: that.$l('table_label_supName') || '面料工厂',
    field: 'supName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryNumber') || '工厂面料编号',
    field: 'factoryNumber',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
